import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const toggleNumPadAtom = atomWithStorage("toggleNumPad", true);

const useToggleNumPad = () => {
  const atom = useAtom(toggleNumPadAtom);
  return atom;
};

export const useSetToggleNumPad = () => useSetAtom(toggleNumPadAtom);

export default useToggleNumPad;
